//@flow

// import Carousel from "@modules/Carousel";'
import { pubsub } from "@utils/";
import { enableBodyScroll, disableBodyScroll } from "@utils/toggleBodyScroll";

class Lightbox {
    $el: HTMLElement;
    $inner: HTMLElement;
    $container: HTMLElement;
    $contents: HTMLElement;
    $closeButton: HTMLElement;
    id: string;
    additionalClass: ?string;
    transitionDuration: number;
    props: any;
    // isCarousel: boolean;
    // carousel: any;
    // carouselStartAt: number;
    onClose: (index?: number) => void;
    onOpen: (index?: number) => void;

    constructor(props: any) {
        this.props = props;
        this.id = props.$element
            ? props.$element.getAttribute("data-lightbox")
            : "";
        this.$contents = props.contents ? props.contents : props.$element;
        // this.isCarousel = props.carousel;
        // this.carouselStartAt = props.carouselStartAt;
        this.onClose = props.onClose;
        this.onOpen = props.onOpen;
        this.additionalClass = props.additionalClass;
        this.transitionDuration = 1000;

        // startup
        this.init();
    }

    init() {
        pubsub.subscribe(`open-${this.id}`, () => {
            this.openLightbox();
        });

        pubsub.subscribe(`close-${this.id}`, () => {
            this.closeLightbox();
        });

        pubsub.subscribe(`close-lightboxes`, () => {
            this.closeLightbox();
        });

        if (this.props.preopen) {
            // this.openLightbox();
            pubsub.publish(`open-${this.id}`);
        }
    }

    attachEvents() {
        if (this.$closeButton) {
            this.$closeButton.addEventListener("click", (event: any): any => {
                this.closeLightbox();
            });
        }
    }

    openLightbox() {
        // create lighbox element
        this.$el = document.createElement("div");
        this.$el.classList.add("lightbox");
        if (this.additionalClass) {
            this.$el.classList.add(this.additionalClass || "");
        }
        this.$el.setAttribute("aria-modal", "true");
        this.$el.setAttribute("data-lightbox-id", this.id);

        // create contents container element
        this.$inner = document.createElement("div");
        this.$inner.classList.add("lightbox__contents");

        // create container element
        this.$container = document.createElement("div");
        this.$container.classList.add("lightbox__container");

        // create close button if not already present
        if (
            !this.$contents.querySelector(".lightbox__close") &&
            !this.props.noclose
        ) {
            this.$closeButton = document.createElement("button");
            this.$closeButton.setAttribute("type", "button");
            this.$closeButton.setAttribute("aria-label", "Close Lightbox");
            this.$closeButton.classList.add("lightbox__close");
            this.$container.append(this.$closeButton);
        } else if (this.$contents.querySelector(".lightbox__close")) {
            this.$closeButton = this.$contents.querySelector(
                ".lightbox__close"
            );
        }

        // add elements to lightbox
        this.$container.appendChild(this.$contents);
        this.$inner.appendChild(this.$container);
        this.$el.appendChild(this.$inner);

        // append lightbox with contents to body
        const $body = document.querySelector("body");
        if ($body) {
            disableBodyScroll();

            $body.appendChild(this.$el);
            this.$el.classList.add("is-active");
        }

        // if carousel then init lightbox carousel
        // if (this.isCarousel) {
        //     // add carousel container classes
        //     this.$container.classList.add("container-fluid");
        //     this.$container.classList.add("container-fluid--large");
        //     this.$container.classList.add("lightbox__container");
        //     //this.$container.classList.add("container-fluid--bleed-right");

        //     // create lightbox carousel
        //     this.carousel = new Carousel({
        //         element: this.$contents,
        //         startAt: this.carouselStartAt,
        //     });
        // }

        // events
        this.attachEvents();

        if (this.onOpen) {
            this.onOpen();
        }
    }

    closeLightbox() {
        this.$el.classList.remove("is-active");

        setTimeout(() => {
            // re enable body scroll
            enableBodyScroll();

            // if (this.isCarousel) {
            //     this.onClose(this.carousel.GlideCarousel.index);
            // }

            // remove lightbox
            this.$el.remove();
        }, this.transitionDuration);
    }
}

export default Lightbox;
